<template src="../../templates/objects/o-loaderInline/o-loaderInline.twig"></template>

<script>
export default {
    name: 'InlineLoader',
}
</script>
